import { ReactHookFormSelect } from "../../../utils";
import { Typography, TextField, makeStyles, Button, Grid, MenuItem } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
    victims: {
        marginTop: "30px"
    }
}));

const Incident = (props) => {
    const { incidentOption, fetchAPI, issues, MultiHandleOptionsTask } = props;
    const classes = useStyles();
    const { control, errors, register, handleSubmit, reset: resetForm } = useForm();

    const [addChange, setAddChange] = useState({
        idVehicleType: "",
        idVehicleClass: "",
        idIncidentType: "",
        idIncidentDetails: "",
        idDriverGender: "",
        idIncidentCause: "",
        idDetailsIncidentCause: "",
    });

    const [loading, setLoading] = useState({
        incidentDetails: false,
        factorDetails: false,
    });

    const {
        idVehicleType,
        idVehicleClass,
        idIncidentType,
        idIncidentDetails,
        idDriverGender,
        idIncidentCause,
        idDetailsIncidentCause,
    } = addChange;

    const [state, setState] = useState({
        error: ""
    });

    const isFormValid = () => {
        return (
            addChange.idVehicleType &&
            addChange.idVehicleClass &&
            addChange.idIncidentType &&
            addChange.idIncidentDetails &&
            addChange.idDriverGender !== "" &&
            addChange.idIncidentCause &&
            addChange.idDetailsIncidentCause &&
            addChange.lightInjuryVictims !== "" &&
            addChange.seriouslyInjuryVictim !== "" &&
            addChange.victimDied !== "" &&
            addChange.vehicleInvolved !== ""
        );
    }

    const renderError = () => {
        return state.error ? (
            <div className="alert alert-danger">{state.error}</div>
        ) : null;
    };

    const resetAllForm = () => {
        setState({ error: "" });
        setAddChange({
            idVehicleType: "",
            idVehicleClass: "",
            idIncidentType: "",
            idIncidentDetails: "",
            idDriverGender: "",
            idIncidentCause: "",
            idDetailsIncidentCause: "",
        });
        resetForm({
            lightInjuryVictims: "",
            seriouslyInjuryVictim: "",
            victimDied: "",
            vehicleInvolved: "",
        });
    }

    const onSubmit = async (data) => {
        if (!isFormValid()) {
            setState({ error: "Semua field wajib harus diisi!" });
            return;
        }

        const dataFetch = {
            idticket: issues?.idticket,
            idkendaraan: addChange.idVehicleType.toString(),
            golongan: addChange.idVehicleClass.toString(),
            sub_jenis_kecelakaan: addChange.idIncidentDetails.toString(),
            subfaktor: addChange.idDetailsIncidentCause.toString(),
            gender: addChange.idDriverGender.toString(),
            korban_meninggal: data.victimDied,
            luka_ringan: data.lightInjuryVictims,
            luka_berat: data.seriouslyInjuryVictim,
            kendaraan_terlibat: data.vehicleInvolved,
        };

        let result = await fetchAPI("addIncident", dataFetch);
        if (result.status === "success") {
            resetAllForm();
        }
        return result;
    }

    useEffect(() => {
        const fetchData = async () => {
            if (idIncidentType) {
                setLoading(prev => ({ ...prev, incidentDetails: true }));
            }

            if (idIncidentCause) {
                setLoading(prev => ({ ...prev, factorDetails: true }));
                setAddChange(prev => ({
                    ...prev,
                    idDetailsIncidentCause: ""
                }));
            }

            if (idIncidentCause || idIncidentType) {
                await MultiHandleOptionsTask({
                    params: {
                        idIncidentCause,
                        idIncidentType,
                    }
                });

                setLoading({
                    incidentDetails: false,
                    factorDetails: false,
                });
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idIncidentCause, idIncidentType]);

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Typography variant="h6">Incident</Typography>
                {renderError()}

                <ReactHookFormSelect
                    register={register}
                    id="idVehicleType"
                    name="idVehicleType"
                    label="VEHICLE TYPE"
                    control={control}
                    error={errors.idVehicleType}
                    value={idVehicleType}
                    setState={setAddChange}
                    state={addChange}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    required
                    disabled={!incidentOption.optionVehicles}
                >
                    <MenuItem value="none" disabled>
                        --Pilih Jenis kendaraan--
                    </MenuItem>
                    {incidentOption.optionVehicles ? (
                        incidentOption.optionVehicles.map((item, i) => (
                            <MenuItem key={i} value={item.id}>
                                {item.nama}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled>Loading...</MenuItem>
                    )}
                </ReactHookFormSelect>

                <ReactHookFormSelect
                    id="idVehicleClass"
                    name="idVehicleClass"
                    label="VEHICLE CLASS"
                    control={control}
                    error={errors.idVehicleClass}
                    value={idVehicleClass}
                    setState={setAddChange}
                    state={addChange}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    required
                >
                    <MenuItem value="none" disabled>
                        --Pilih Golongan Kendaraan--
                    </MenuItem>
                    {[1, 2, 3, 4, 5].map((val) => (
                        <MenuItem value={val} key={val}>{val}</MenuItem>
                    ))}
                </ReactHookFormSelect>

                <ReactHookFormSelect
                    id="idIncidentType"
                    name="idIncidentType"
                    label="INCIDENT TYPE"
                    control={control}
                    error={errors.idIncidentType}
                    value={idIncidentType}
                    setState={setAddChange}
                    state={addChange}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    required
                    disabled={!incidentOption.optionIncidentType}
                >
                    <MenuItem value="none" disabled>
                        --Pilih Jenis Kecelakaan--
                    </MenuItem>
                    {incidentOption.optionIncidentType ? (
                        incidentOption.optionIncidentType.map((item, i) => (
                            <MenuItem key={i} value={item.id}>
                                {item.nama}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled>Loading...</MenuItem>
                    )}
                </ReactHookFormSelect>

                <ReactHookFormSelect
                    id="idIncidentDetails"
                    name="idIncidentDetails"
                    label={loading.incidentDetails ? "LOADING..." : "INCIDENT DETAILS TYPE"}
                    control={control}
                    error={errors.idIncidentDetails}
                    value={idIncidentDetails}
                    setState={setAddChange}
                    state={addChange}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    required
                    disabled={loading.incidentDetails || !incidentOption.optionIncidentTypeDetails}
                >
                    <MenuItem value="none" disabled>
                        --Pilih Jenis Detail Kecelakaan--
                    </MenuItem>
                    {loading.incidentDetails ? (
                        <MenuItem disabled>Loading...</MenuItem>
                    ) : incidentOption.optionIncidentTypeDetails && incidentOption.optionIncidentTypeDetails.length > 0 ? (
                        incidentOption.optionIncidentTypeDetails.map((item, i) => (
                            <MenuItem key={i} value={item.id}>
                                {item.nama}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled>Pilih Incident Type terlebih dahulu</MenuItem>
                    )}
                </ReactHookFormSelect>

                <ReactHookFormSelect
                    id="idDriverGender"
                    name="idDriverGender"
                    label="DRIVER GENDER"
                    control={control}
                    error={errors.idDriverGender}
                    value={idDriverGender}
                    setState={setAddChange}
                    state={addChange}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    required
                >
                    <MenuItem value="none" disabled>
                        --Pilih Jenis Kelamin Pengemudi--
                    </MenuItem>
                    <MenuItem value="0" key={0}>FEMALE</MenuItem>
                    <MenuItem value="1" key={1}>MALE</MenuItem>
                    <MenuItem value="2" key={2}>UNKNOWN</MenuItem>
                </ReactHookFormSelect>

                <ReactHookFormSelect
                    id="idIncidentCause"
                    name="idIncidentCause"
                    label="INCIDENT CAUSE"
                    control={control}
                    error={errors.idIncidentCause}
                    value={idIncidentCause}
                    setState={setAddChange}
                    state={addChange}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    required
                    disabled={!incidentOption.optionFactors}
                >
                    <MenuItem value="none" disabled>
                        --Pilih Jenis Penyebab--
                    </MenuItem>
                    {incidentOption.optionFactors ? (
                        incidentOption.optionFactors.map((item, i) => (
                            <MenuItem key={i} value={item.id}>
                                {item.nama}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled>Loading...</MenuItem>
                    )}
                </ReactHookFormSelect>

                <ReactHookFormSelect
                    id="idDetailsIncidentCause"
                    name="idDetailsIncidentCause"
                    label={loading.factorDetails ? "LOADING..." : "INCIDENT DETAILS CAUSE"}
                    control={control}
                    error={errors.idDetailsIncidentCause}
                    value={idDetailsIncidentCause}
                    setState={setAddChange}
                    state={addChange}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    required
                    disabled={loading.factorDetails || !incidentOption.optionFactorsDetails || !idIncidentCause}
                >
                    <MenuItem value="none" disabled>
                        --Pilih Jenis Detail Penyebab--
                    </MenuItem>
                    {loading.factorDetails ? (
                        <MenuItem disabled>Loading...</MenuItem>
                    ) : incidentOption.optionFactorsDetails && incidentOption.optionFactorsDetails.length > 0 ? (
                        incidentOption.optionFactorsDetails.map((item, i) => (
                            <MenuItem key={i} value={item.id}>
                                {item.nama}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled>
                            {idIncidentCause ? "Tidak ada data" : "Pilih Incident Cause terlebih dahulu"}
                        </MenuItem>
                    )}
                </ReactHookFormSelect>

                <div className={classes.victims}>
                    <TextField
                        id="lightInjuryVictims"
                        name="lightInjuryVictims"
                        label="TOTAL LIGHT INJURY VICTIMS"
                        error={errors.lightInjuryVictims}
                        fullWidth
                        placeholder="Enter your total light injury victims"
                        type="number"
                        variant="outlined"
                        inputRef={register({
                            required: {
                                value: true,
                                message: "Jumlah korban luka ringan tidak boleh kosong",
                            },
                        })}
                        InputLabelProps={{ shrink: true }}
                        helperText={errors.lightInjuryVictims && errors.lightInjuryVictims.message}
                    />
                </div>

                <div className={classes.victims}>
                    <TextField
                        id="seriouslyInjuryVictim"
                        name="seriouslyInjuryVictim"
                        label="TOTAL SERIOUS INJURY VICTIMS"
                        error={errors.seriouslyInjuryVictim}
                        fullWidth
                        placeholder="Enter your total seriously injury victims"
                        type="number"
                        variant="outlined"
                        inputRef={register({
                            required: {
                                value: true,
                                message: "Jumlah korban luka berat tidak boleh kosong",
                            },
                        })}
                        InputLabelProps={{ shrink: true }}
                        helperText={errors.seriouslyInjuryVictim && errors.seriouslyInjuryVictim.message}
                    />
                </div>

                <div className={classes.victims}>
                    <TextField
                        id="victimDied"
                        name="victimDied"
                        label="TOTAL VICTIMS DIED"
                        error={errors.victimDied}
                        fullWidth
                        placeholder="Enter your total died victims"
                        type="number"
                        variant="outlined"
                        inputRef={register({
                            required: {
                                value: true,
                                message: "Jumlah korban meninggal tidak boleh kosong",
                            },
                        })}
                        InputLabelProps={{ shrink: true }}
                        helperText={errors.victimDied && errors.victimDied.message}
                    />
                </div>

                <div className={classes.victims}>
                    <TextField
                        id="vehicleInvolved"
                        name="vehicleInvolved"
                        label="TOTAL VEHICLE INVOLVED"
                        error={errors.vehicleInvolved}
                        fullWidth
                        placeholder="Enter your total vehicle involved"
                        type="number"
                        variant="outlined"
                        inputRef={register({
                            required: {
                                value: true,
                                message: "Jumlah kendaraan terlibat tidak boleh kosong",
                            },
                        })}
                        InputLabelProps={{ shrink: true }}
                        helperText={errors.vehicleInvolved && errors.vehicleInvolved.message}
                    />
                </div>

                <Grid
                    className="form-group"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: "0.5rem",
                    }}
                >
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                    >
                        Submit &#10148;
                    </Button>
                </Grid>
            </form>
        </div>
    );
}

export default Incident;